import React from 'react';

import { Box, CircularProgress, Typography, useTheme } from '@liscio/ui';
import { formatPercent } from '@liscio/utils';

// Ring geometry: at this label size "100%" just fits inside the ring's stroke.
// The theme's smallest variant (caption, 0.8rem) would need a 42px ring.
const RING_SIZE = 36;
const RING_LABEL_FONT_SIZE = '0.65rem';

type CompletionCellProps = {
  completionPercentage: number;
};

export const CompletionCell = ({
  completionPercentage,
}: CompletionCellProps) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        position: 'relative',
        display: 'inline-flex',
        verticalAlign: 'middle',
      }}
    >
      <CircularProgress
        variant="determinate"
        value={completionPercentage}
        size={RING_SIZE}
        thickness={4}
        color="info"
        sx={{
          boxShadow: `inset 0px 0px 1px 3px ${theme.palette.common.neutrals[100]}`,
          borderRadius: '50%',
        }}
      />
      <Box
        sx={{
          inset: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography
          variant="caption"
          component="div"
          sx={{ color: 'text.primary', fontSize: RING_LABEL_FONT_SIZE }}
        >
          {formatPercent(completionPercentage)}
        </Typography>
      </Box>
    </Box>
  );
};
